"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfigUrl = exports.default = void 0;
var _genericFunction = require("../helpers/genericFunction");
var baseUrl = (0, _genericFunction.getApiGatewayUrl)();
var tokenExpiryTIme = 60;
var refreshTime = 20;
var config = {
  dashboard: {
    localStorage: {
      dashboardAuthSessionKey: process.env.REACT_APP_DASHBOARD_SESSION_AUTH_KEY
    }
  },
  baseUrl: baseUrl,
  tokenExpiryTIme: tokenExpiryTIme,
  refreshTime: refreshTime
};
var setConfigUrl = function setConfigUrl() {
  config.baseUrl = (0, _genericFunction.getApiGatewayUrl)();
};
exports.setConfigUrl = setConfigUrl;
var _default = config;
exports.default = _default;